import BaseClient from '@/app/model/api/response/baseApiClient'

class NewsBoardContentsListApi extends BaseClient {
  public getNewsBoardContentsList (data: any) {
    const path = '/v1/news-board-contents'
    var url = new URL(process.env.VUE_APP_API_URL + path)
    var params = new URLSearchParams({})

    if (data.news_board_id !== undefined) {
      params.append('news_board_id', data.news_board_id)
    }
    if (data.variety_id !== undefined) {
      params.append('variety_id', data.variety_id)
    }
    if (data.district_id !== undefined) {
      params.append('district_id', data.district_id)
    }

    url.search = params.toString()

    /* 共通処理 */
    return super.doFetch(decodeURI(url.href), 'GET')
  }
}

export default new NewsBoardContentsListApi()
